import React from "react";
import About from "../Components/about/About";
import PageHeader from "../Components/common/PageHeader";
import Contact from "../Components/contact/Contact";
import SEO from "../Components/common/SEO";
import { useTranslation } from "react-i18next";
// import Spacer2 from "../Components/common/Spacer2";

function AboutPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/hakkimizda`;

  const aboutStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    'name': 'Seymen Kimya Hakkında',
    'description': 'Seymen Kimya\'nın misyonu, vizyonu ve şirket hikayesi',
    'url': pageUrl,
    'mainEntity': {
      '@type': 'Organization',
      'name': 'Seymen Kimya',
      'description': 'Kaliteli hammadde ve ileri teknoloji kullanarak, uluslararası standartlarda, çevreye duyarlı ve kullanıcı sağlığını ön planda tutan temizlik ve kimyasal ürünler üretmektedir.',
      'foundingDate': '2010',
      'industry': 'Kimya ve Temizlik Ürünleri',
      'numberOfEmployees': '50-100',
      'address': {
        '@type': 'PostalAddress',
        'addressCountry': 'TR',
        'addressLocality': 'Bursa'
      },
      'contactPoint': {
        '@type': 'ContactPoint',
        'telephone': '+90-224-360-1166',
        'contactType': 'customer service'
      }
    }
  };

  return (
    <>
      <SEO
        title="Hakkımızda | Seymen Kimya - Güvenilir Kimya Çözümleri"
        description="Seymen Kimya olarak kaliteli hammadde ve ileri teknoloji ile çevreye duyarlı temizlik ürünleri üretiyoruz. Misyonumuz ve vizyonumuzu keşfedin."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/about/about.webp`}
        structuredData={aboutStructuredData}
      />
      <PageHeader title={t("HAKKIMIZDA")} />
      <About />
    </>
  );
}

export default AboutPage;
